import MenuIcon from "@mui/icons-material/Menu";
import {
  Button,
  Fab,
  IconButton,
  ListItemText,
  Typography,
  Badge,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useEffect, useState, createContext } from "react";
// import IconButton from "@mui/material/IconButton";
import styles from "../Styles/mainHeader.module.css";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
import { useLocation, useNavigate } from "react-router-dom";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { Vocabulary } from "../Utils/Vocabulary";
import { logout } from "../Utils/Utils";
import useNoActivity from "../Hooks/useNoActivity";
import { UserModel } from "../Utils/Models";
import { getData } from "../Services/getData";
import genericStyles from "../Styles/genericStyles.module.css";
import GlobalSearchComponent from "./GlobalSearchComponent";
import { MainHeaderProps } from "../Utils/Types";
import { ExpandMore } from "@mui/icons-material";
import Notifications from "./Widgets/Notifications";
import withRole from "../Hooks/withRole";
import { useUnprocessedOnlineClientsCount } from "../Hooks/useUnprocessedOnlineClientsCount";
import MyAccountModal from "./Users/MyAccountModal";

export const CRUDContext = createContext(new UserModel());
let logoutTimeout: any;

function MainHeader(props: MainHeaderProps, location: any) {
  location = useLocation();
  const [contextValue, setContextValue] = useState(new UserModel());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const hasActivity = useNoActivity();
  const open = Boolean(anchorEl);
  const userId = localStorage.getItem("userId");
  const [anchorEls, setAnchorEls] = useState<{
    [key: number]: HTMLElement | null;
  }>({});
  const unprocessedCount = useUnprocessedOnlineClientsCount();
  const [openMyAccountModal, setOpenMyAccountModal] = useState(false);


  const handleOpenMenu = (
    event: React.MouseEvent<HTMLElement>,
    key: number
  ) => {
    event.preventDefault();
    setAnchorEls((prev) => ({ ...prev, [key]: event.currentTarget }));
  };

  const handleCloseMenu = (key: number) => {
    setAnchorEls((prev) => ({ ...prev, [key]: null }));
  };

  const handleNavigate = (path: string, key: number | null) => {
    if (path !== location.pathname && path !== location.pathname + "?")
      navigate(path);
    if (key) handleCloseMenu(key);
  };

  /**
   *
   */
  useEffect(() => {
    if (!hasActivity) {
      logoutTimeout = setTimeout(() => {
        handleLogout();
      }, 1000 * 60 * 5);
    } else {
      if (logoutTimeout) {
        clearTimeout(logoutTimeout);
      }
    }
  }, [hasActivity]);

  /**
   *
   * @returns
   */
  const getUserInfo = async () => {
    const url = `${endpoints.user.main}/${userId}`;
    const res = (await getData(url)) as any;
    if (!res || res?.error) {
      return;
    }
    setContextValue(res?.data);
  };

  /**
   *
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   *
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   *
   */
  const handleLogout = async () => {
    setAnchorEl(null);
    logout();
    navigate(localUrlEnum.login);
  };

  /**
   * Open my account modal
   */
  const redirectToSettings = () => {
    setAnchorEl(null);
    setOpenMyAccountModal(true);
  };

  const userName = localStorage.getItem("fullName") || localStorage.getItem("userName");

  const renderAccount = () => {
    return (
      <div className={styles.secondContainer}>
        <Fab
          onClick={(event: any) => {
            getUserInfo();
            handleClick(event);
          }}
          size="small"
          className={styles.userSettingsAvatar}
          aria-label="add"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <AccountCircleIcon />
        </Fab>
        <Typography className={styles.username}>{`${userName} `}</Typography>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={redirectToSettings}>
            <Avatar />
            {Vocabulary.myAccount}
          </MenuItem>
          {/* <Divider />
          <MenuItem>
            <ListItemIcon>
              <Info fontSize="small" />
            </ListItemIcon>
            <a
              style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.80" }}
              href="intro.html"
              target="_blank"
            >
              {Vocabulary.userManual}
            </a>
          </MenuItem> */}
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            {Vocabulary.logout}
          </MenuItem>
        </Menu>
      </div>
    );
  };
  return (
    <CRUDContext.Provider value={contextValue}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          {/* Left: hamburger + account */}
          <div className={styles.leftGroup}>
            <div className={styles.iconMenu}>
              <IconButton
                style={{ backgroundColor: "#fff" }}
                aria-label="menu"
                onClick={() => props.setHideSlider()}
              >
                <MenuIcon />
              </IconButton>
            </div>
            {renderAccount()}
          </div>
          {/* Center: desktop nav */}
          <div className={styles.appBar}>
            {props.data?.map((page: any, key: number) => {
                // Check if this is the Online Clients menu item
                const isOnlineClientsPage =
                  page?.path === localUrlEnum.onlineClients;
                return (
                  <div key={page?.name}>
                    <Button
                      type="button"
                      key={page?.name}
                      className={styles.menuButton}
                      onClick={(event) =>
                        page?.children
                          ? handleOpenMenu(event, key)
                          : handleNavigate(page?.path, null)
                      }
                      sx={{
                        my: 1,
                        display: "flex",
                        alignItems: "center",
                        marginRight: "25px",
                        fontSize: "1rem",
                        position: "relative",
                      }}
                    >
                      {isOnlineClientsPage && unprocessedCount > 0 ? (
                        <Badge
                          badgeContent={unprocessedCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              backgroundColor: "#fff",
                              color: "#ef4444",
                              right: "-12px",
                              top: "-5px",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              minWidth: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                              border: "2px solid #ef4444",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              animation: "pulse 2s infinite",
                              "@keyframes pulse": {
                                "0%": {
                                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
                                },
                                "50%": {
                                  boxShadow: "0 4px 20px rgba(239, 68, 68, 0.6)",
                                },
                                "100%": {
                                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
                                },
                              },
                            },
                          }}
                        >
                          <span>{page?.name}</span>
                        </Badge>
                      ) : (
                        page?.name
                      )}
                      {page?.children && <ExpandMore />}
                    </Button>
                    {page.children && (
                      <Menu
                        anchorEl={anchorEls[key]}
                        open={Boolean(anchorEls[key])}
                        onClose={() => handleCloseMenu(key)}
                        sx={{ borderRadius: "20px !important" }}
                      >
                        {page.children.map((child: any, index: number) => (
                          <MenuItem
                            key={index}
                            onClick={() => handleNavigate(child.path, key)}
                          >
                            <ListItemIcon> {child.icon} </ListItemIcon>
                            <ListItemText
                              disableTypography
                              sx={{ fontSize: "1rem !important" }}
                            >
                              {child.name}
                            </ListItemText>
                          </MenuItem>
                        ))}
                      </Menu>
                    )}
                  </div>
                );
              })}
          </div>
          {/* Right: notifications */}
          <div className={styles.secondContainer}>
            <Notifications />
          </div>
        </div>

        {props.shouldRenderSearchBar && (
          <div className={genericStyles.searchField}>
            <GlobalSearchComponent />
          </div>
        )}
      </div>

      <MyAccountModal
        open={openMyAccountModal}
        onClose={() => setOpenMyAccountModal(false)}
        userData={contextValue}
      />
    </CRUDContext.Provider>
  );
}

export default withRole(MainHeader);
